import IPortalComment from "../IPortalComment";

const InitialComment: IPortalComment = {
    content: "",
    emailOfPerson: "",
    nameOfPerson: "",
};

export default InitialComment;
